import { ICON__user_gear } from '@/assets/icons_fa';
import { ENUM__page_type } from '@/enums/ENUM__page_type';
import { use_slice_user } from '@/hooks/store/use_slices';
import i18n_base_ui from '@/locales/keys/i18n_base_ui.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { useTranslation } from 'react-i18next';
import { PLACEHOLDER_BUTTON__bar_10_5 } from '../../buttons/PLACEHOLDER_BUTTON__bar_10_5';
import { BUTTON__navigation_desktop } from '../desktop/BUTTON__navigation_desktop';

export function BUTTON__navigation_settings() {
  const { t } = useTranslation(ENUM__i18n_namespace.BASE_UI);

  const { is_authorized } = use_slice_user(['is_authorized']);

  if (!is_authorized) return <PLACEHOLDER_BUTTON__bar_10_5 />;

  return (
    <>
      <BUTTON__navigation_desktop
        page_type={ENUM__page_type.SETTINGS_USER_WITHOUT_PARAMS}
        tooltip_title={t(i18n_base_ui.sidebar_navigation.tabs.settings_user.tooltip.title)}
        title={t(i18n_base_ui.sidebar_navigation.tabs.settings_user.title)}
        Icon={ICON__user_gear}
        disabled={!is_authorized}
      />
    </>
  );
}
